import { useState } from 'react';

import { useGetStatisticsQuery } from '@/modules/stats';
import { useShowResponseStatus } from '@/shared';

import type { TGetStatisticsParams } from '../store/types';

const initialParams: TGetStatisticsParams = {};

export const useGetStatistics = (initialFilter: TGetStatisticsParams = initialParams) => {
  const [params, setParams] = useState<TGetStatisticsParams>(initialFilter);
  const { data, isLoading, isError } = useGetStatisticsQuery(params);
  const items = data ?? [];

  useShowResponseStatus({
    isError,
    errorMassage: 'Произошла ошибка!',
  });

  const handleFilterChange = (data: TGetStatisticsParams) => {
    setParams({ ...initialParams, ...data });
  };

  const handleFilterReset = () => {
    setParams({ ...initialFilter });
  };

  return {
    items,
    isLoading,
    handleFilterChange,
    handleFilterReset,
  };
};
